/**
 * @see https://fontawesome.com/how-to-use/with-the-api/setup/importing-icons
 */

import {library} from '@fortawesome/fontawesome-svg-core'
// import {} from '@fortawesome/free-solid-svg-icons'
// import {} from '@fortawesome/free-regular-svg-icons'
// import {} from '@fortawesome/free-brands-svg-icons'
// import {} from '@fortawesome/pro-solid-svg-icons'
// import {} from '@fortawesome/pro-regular-svg-icons'

import { faCog } from '@fortawesome/pro-light-svg-icons/faCog'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp'
import { faClone } from '@fortawesome/pro-light-svg-icons/faClone'
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
import { faSave } from '@fortawesome/pro-light-svg-icons/faSave'
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes'
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil'
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'



// Add all icons to the library so you can use it in your page
library.add(
  faCog,
  faChevronDown,
  faChevronUp,
  faClone,
  faTrash,
  faSave,
  faTimes,
  faPencil,
  faPlus
);

export default library;



// WEBPACK FOOTER //
// ./public/themes/frontend/mtg/assets/js/icons.js